var ShipmentDto = (function () {
    function ShipmentDto(id, methodId, shipmentTotal, name) {
        if (id === void 0) { id = ''; }
        if (methodId === void 0) { methodId = ''; }
        this.id = id;
        this.methodId = methodId;
        this.shipmentTotal = shipmentTotal;
        this.name = name;
    }
    ShipmentDto.fromOcapi = function (ocapiShipment) {
        var _a, _b;
        return new ShipmentDto(ocapiShipment.shipment_id, ((_a = ocapiShipment.shipping_method) === null || _a === void 0 ? void 0 : _a.id) || '', ocapiShipment.shipment_total, (_b = ocapiShipment.shipping_method) === null || _b === void 0 ? void 0 : _b.name);
    };
    return ShipmentDto;
}());
export { ShipmentDto };
//# sourceMappingURL=ShipmentDto.js.map